'use strict'

module.exports = require('i-s').numeric


/*****************
 ** WEBPACK FOOTER
 ** ./~/ustring/src/is/numeric.js
 ** module id = 849
 ** module chunks = 0
 **/